<div class="d-flex justify-content-end align-items-center p-3">
  <ng-content></ng-content>
</div>
